import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
const initSlider = () => {
  const heroSwiper = new Swiper(".hero-swiper", {
    modules: [Autoplay, EffectFade],
    loop: true,
    speed: 2000,
    centeredSlides: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 2000,
      disableOnInteraction: true,
    },
  });
  const teaseSwiper = new Swiper(".logo-slider-swiper", {
    modules: [Autoplay],
    slidesPerView: "auto",
    loop: true,
    speed: 2000,
    spaceBetween: 30,
    autoplay: true,
  });
};
export default initSlider;
